export default "__VITE_ASSET__C7WYPLYt__"